<template>
  <header class="flex justify-center w-full bg-coal gap-5 text-sm z-[1000]">
    <div
      class="relative flex justify-between items-center w-full xl:w-5/6 py-3 max-xl:px-3"
    >
      <router-link to="/yp" class="text-gold max-md:hidden"
        >miningguide.mn</router-link
      >
      <div
        class="flex items-center max-md:justify-between max-md:w-full gap-3 sm:gap-5 text-white max-md:text-sm"
      >
        <router-link to="/yp/contact" class="max-sm:hidden hover:underline">{{
          lang === "mn" ? "Холбоо барих" : "Contact"
        }}</router-link>
        <p class="flex items-center">
          <font-awesome-icon icon="fa-solid fa-phone-volume" class="mr-1" />
          (+976) 70110163
        </p>

        <div class="flex bg-white rounded-xl">
          <button
            @click="toggleLanguage()"
            class="w-9 px-2 py-1 uppercase text-coal"
            :class="lang === 'mn' ? 'bg-gold rounded-xl' : ''"
          >
            <img
              src="../../assets/images/YellowPage/mn.svg"
              alt="MN"
              class="w-7 object-contain"
            />
          </button>
          <button
            @click="toggleLanguage()"
            class="w-9 px-2 py-1 uppercase text-coal"
            :class="lang === 'en' ? 'bg-gold rounded-xl' : ''"
          >
            <img
              src="../../assets/images/YellowPage/us.svg"
              alt="US"
              class="w-7 object-contain"
            />
          </button>
        </div>
      </div>

      <div class="absolute bottom-0 left-10"></div>
    </div>
  </header>

  <nav
    ref="navRef"
    class="sticky top-0 flex justify-center w-full bg-white text-md shadow-md z-30"
    :class="[
      isCategory ? 'border-b border-coal' : '',
      isRoute === '/yp/register' ? 'hidden' : '',
    ]"
  >
    <div
      class="flex max-md:flex-col md:justify-between items-center max-md:gap-3 w-full xl:w-5/6 py-3 max-xl:px-3"
    >
      <router-link
        to="/yp"
        @click="closeCategory()"
        class="flex flex-col gap-1 max-md:items-center"
      >
        <img
          src="../../assets/images/YellowPage/miningguide_logo.png"
          alt="logo"
          class="w-32 object-contain"
        />
        <h6 class="text-coal text-xs max-md:text-center">
          {{
            lang === "mn"
              ? "Монголын уул уурхайн нэгдсэн лавлах"
              : "Mongolian mining directory"
          }}
        </h6>
      </router-link>

      <div class="space-x-5 text-coal max-sm:text-sm">
        <button
          @click="toggleCategory()"
          class="p-2 border-2 border-transparent hover:border-b-gold"
        >
          {{ lang === "mn" ? "Ангилал" : "Categories" }}
          <font-awesome-icon
            v-if="!isCategory"
            icon="fa-solid fa-chevron-down"
            class="ml-1"
          />
          <font-awesome-icon
            v-else
            icon="fa-solid fa-chevron-up"
            class="ml-1"
          />
        </button>
        <router-link
          to="/yp/register"
          @click="closeCategory()"
          class="bg-gold p-3 rounded"
        >
          <font-awesome-icon icon="fa-solid fa-square-plus" class="mr-1" />
          {{ lang === "mn" ? "Мэдээлэл нэмэх" : "Contribute Information" }}
        </router-link>
      </div>
    </div>
  </nav>

  <transition v-if="isCategory" v-motion-slide-visible-top>
    <div
      class="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-20 h-full w-full overflow-y-scroll"
      @click="toggleCategory()"
    >
      <div
        @click.stop
        class="absolute flex justify-center bg-white w-full"
        :style="{ top: dropdownTop }"
      >
        <div
          class="columns-1 sm:columns-2 md:columns-3 lg:columns-4 w-full xl:w-5/6 max-xl:px-3 py-5 md:py-10"
        >
          <ul v-for="category in categories" :key="category.id" class="mb-5">
            <li
              class="uppercase font-bold text-black text-lg mb-3 cursor-pointer hover:text-coal"
            >
              <router-link
                :to="`/yp/category/${category.id}`"
                @click="toggleCategory()"
              >
                {{ category.id }}.
                {{ lang === "mn" ? category.nameMn : category.nameEn }}
              </router-link>
            </li>
            <li
              v-for="sub in category.subCategories"
              :key="sub.category_code"
              class="text-coal text-sm font-light mb-1 cursor-pointer hover:underline"
            >
              <router-link
                :to="`/yp/category/${sub.category_code}`"
                @click="toggleCategory()"
              >
                {{ sub.category_code }} {{ sub.name }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  computed,
  nextTick,
  onMounted,
  onUnmounted,
  ref,
  watch,
  watchEffect,
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "YellowHome",
  setup() {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    const toggleLanguage = () => {
      store.dispatch("toggleLanguage");
    };

    const route = useRoute();
    const isRoute = ref(route.path);

    watch(
      () => route.path,
      (newPath) => {
        isRoute.value = newPath;
      }
    );

    const isCategory = ref(false);
    const toggleCategory = () => {
      isCategory.value = !isCategory.value;
    };
    const closeCategory = () => {
      if (isCategory.value) {
        isCategory.value = !isCategory.value;
      }
    };

    const categories = ref([]);

    const fetchAllCategories = async () => {
      try {
        const response = await store.dispatch(
          "yellow/fetchAllCategories",
          lang.value
        );
        if (response?.data?.categories) {
          categories.value = response.data.categories;
        } else {
          console.warn("No categories in response", response);
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };

    watch(
      isCategory,
      (val) => {
        if (val) {
          const existingCategories = store.getters["yellow/getAllCategories"];
          if (!existingCategories || existingCategories.length === 0) {
            fetchAllCategories();
          } else {
            categories.value = existingCategories;
          }
        }
      },
      { immediate: true }
    );

    watch(lang, async (newLang, oldLang) => {
      if (newLang !== oldLang) {
        await fetchAllCategories();
      }
    });

    watchEffect(() => {
      if (isCategory.value) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
    });

    const navRef = ref(null);
    const dropdownTop = ref("0px");

    const calculateDropdownPosition = () => {
      if (navRef.value) {
        const rect = navRef.value.getBoundingClientRect();
        dropdownTop.value = `${rect.bottom}px`;
      }
    };

    onMounted(() => {
      calculateDropdownPosition();
      window.addEventListener("resize", calculateDropdownPosition);
    });

    watch(isCategory, (val) => {
      if (val) nextTick(() => calculateDropdownPosition());
    });

    const isSticky = ref(false);

    const handleScroll = () => {
      if (navRef.value) {
        const { top } = navRef.value.getBoundingClientRect();
        isSticky.value = top <= 0;
      }
    };

    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });

    return {
      lang,
      toggleLanguage,
      isRoute,
      isCategory,
      toggleCategory,
      closeCategory,
      categories,
      navRef,
      dropdownTop,
      isSticky,
    };
  },
};
</script>
